import React, { ReactNode } from 'react';

import logoLight from '@/assets/logos/logo-light.svg';
import logoDark from '@/assets/logos/logo-dark.svg';

export interface LayoutProps {
  children: ReactNode;
}
const Layout = ({ children }: LayoutProps) => {
  return (
    <main className="flex flex-col items-center justify-center min-h-screen dark:bg-blue-1100 bg-grey-300">
      <div className="flex flex-col w-full max-w-xl px-5 mx-auto">
        <div className="flex flex-col items-center mb-10">
          <img
            src={logoLight}
            alt="Swift SMS Gateway"
            width={250}
            height={150}
            className="block dark:hidden"
          />
          <img
            src={logoDark}
            alt="Swift SMS Gateway"
            width={250}
            height={150}
            className="hidden dark:block"
          />
        </div>
        {children}
      </div>
    </main>
  );
};

export default Layout;
